import React, { useEffect, useState, useContext } from 'react';
import { useParams } from 'react-router-dom';
import Button from '../../forms/Button';
import Input from '../../forms/Input';
import FormSetting from '../../layout/FormSetting';
import GetState from '../../GetState';
import { QuestRoute } from '../../api/QuestRoutes';
import HamQuest from '../../api/HamQuestGiver';
import ModalFactory from '../../Modal';
import Form from '../../forms/Form';
import { generateId } from '../../utility/functions';
import Radio from '../../forms/Radio';
import Checkbox from '../../forms/Checkbox';
import useDebounce from '../../utility/debounce';
import { UserContexts } from '../../stateProvider/UsersContext';
import { userRoles } from '../../RoleProtected';

const AccountCredit = ({ ...props }) => {

    const { guid } = useParams();
    const context = useContext(UserContexts)

    const [accountBalance, refreshAccountBalance, setAccountBalance] = GetState(QuestRoute.user.accountBalance(guid))

    const addFunds = (id = generateId()) => ModalFactory.show({
        id,
        title: 'Add Funds',
        body: (
            <Form
                inputs={{ credit: 0 }}
                onSubmit={e => (
                    ModalFactory.close(id),
                     ModalFactory.confirmAndProcess({
                        confirmation: {
                        type: 'warning',
                        title: 'Warning',
                        body: <span>Adding Balance is non-reversable, are you sure you want to add ${e.credit} to {context.user.fullName}'s App Credit</span>,
                        slideToAccept: true,
                    },
                        promise: {
                        title: 'Adding Funds',
                        body: 'Adding funds to the account',
                        callback: () => HamQuest.put(QuestRoute.user.accountBalance(guid), { ...e }).then(res => {
                            setAccountBalance(res) 
                        }),
                    },
                        confirmed: {
                        title: 'Added Funds',
                        body: 'Funds have been added to the account',
                        }
                    }
                )
                )}
            >
                <Input
                    label='Balance'
                    name='credit'
                    type='price'
                    min={0}
                    required
                />
            </Form>
        )
    })

    return (
        <FormSetting
            label='Account Balance'
            inputs={{ credit: accountBalance }}
            controls={[
                <Button
                    label='Add Funds'
                    onClick={addFunds}
                    roles={userRoles.admin}
                />
            ]}
        >
            <Input
                label='Balance'
                name='credit'
                type='price'
                readOnly
                disabled
                required
            />
        </FormSetting>
    );
}

export default AccountCredit;
